import React, { useEffect, useState } from 'react';
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import useAuth from '../components/Auth';
import { useUpdateCurrentCompanyMutation } from '../services/companies';

function TeamSettingsView() {
	const { userProfile } = useAuth();
	const [updateCurrentCompany, { isLoading }] = useUpdateCurrentCompanyMutation();
	const [companyName, setCompanyName] = useState(userProfile.companyName ?? '');
	const [error, setError] = useState<string | null>(null);
	const trimmedCompanyName = companyName.trim();

	useEffect(() => {
		setCompanyName(userProfile.companyName ?? '');
	}, [userProfile.companyName]);

	const onSave = async () => {
		if (!trimmedCompanyName) {
			setError('Team name cannot be empty.');
			return;
		}
		try {
			await updateCurrentCompany({ name: trimmedCompanyName }).unwrap();
		} catch {
			setError('Could not update team name. Please try again.');
		}
	};

	return (
		<Container maxWidth='sm' sx={{ mb: 5 }}>
			<Typography variant='h4' component='h1' sx={{ mt: 2, mb: 3 }}>
				Team
			</Typography>
			<form onSubmit={(event) => {
				event.preventDefault();
				onSave();
			}}>
				<Box display='flex' gap={1} alignItems='flex-start'>
					<TextField
						label='Team name'
						size='small'
						fullWidth
						value={companyName}
						onChange={(event) => {
							setError(null);
							setCompanyName(event.target.value);
						}}
						error={Boolean(error)}
						helperText={error ?? ' '}
						disabled={isLoading}
					/>
					<Button
						type='submit'
						variant='contained'
						disabled={isLoading || trimmedCompanyName === userProfile.companyName}
					>
						Save
					</Button>
				</Box>
			</form>
		</Container>
	);
}

export default TeamSettingsView;
